import {
  FilterChip,
  FilterViewerComponentProps,
  extractLastNameComponent,
} from '@spotify/confidence-core-react';

const format = (name: string) => extractLastNameComponent(name);

const formatLabel = (value: string[]) => {
  if (value.length > 1) {
    return `Flags (${value.length})`;
  }

  if (value.length === 1) {
    return `Flag: ${format(value[0])}`;
  }

  return 'No flags selected';
};

export const FlagFilterViewer = (
  props: FilterViewerComponentProps<string[]>,
) => {
  return <FilterChip {...props} label={formatLabel(props.value)} />;
};
